export default {

    iconInside: '<span class="uwr-date-picker-icon-inside uwr-button"/>',

    iconOutside: [
            '<span class="uwr-date-picker-icon-outside-container">',
                '<button class="uwr-date-picker-icon-outside uwr-button" onclick="return false;" type="button"/>',
            '</span>'
        ].join(''),

    inputContainer: '<span class="uwr-date-picker-input-container"></span>',

    calendar: [
            '<div class="uwr-date-picker-calendar">',
                '<div class="uwr-date-picker-calendar-main">',
                    '<div class="uwr-date-picker-month-selector-view">',
                        '<div class="uwr-date-picker-month-selector-label">{{selectMonth}}</div>',
                        '<div class="uwr-date-picker-month-selector"></div>',
                    '</div>',
                    '<div class="uwr-date-picker-day-selector-view">',
                        '<div class="uwr-date-picker-weekdays">',
                            '{{#weekdays}}',
                                '<span>{{.}}</span>',
                            '{{/weekdays}}',
                        '</div>',
                        '<div class="uwr-date-picker-day-selector"></div>',
                    '</div>',
                '</div>',
            '</div>'
        ].join(''),

    yearSelector: [
            '<div class="uwr-date-picker-year-selector">',
                '<button class="uwr-date-picker-prev-year uwr-button uwr-button-small uwr-button-ghost"',
                        ' onclick="return false;">',
                '</button>',
                '<span class="uwr-date-picker-displayed-year">',
                    '<input class="uwr-date-picker-displayed-year-input-label" value="{{displayedYear}}"',
                        ' maxlength="4">',
                '</span>',
                '<button class="uwr-date-picker-next-year uwr-button uwr-button-small uwr-button-ghost"',
                        ' onclick="return false;">',
                '</button>',
            '</div>'
        ].join(''),

    monthSelector: [
            '<div class="uwr-date-picker-month-selector">',
                '{{#months}}',
                    '<div class="uwr-date-picker-month{{#disabled}} uwr-date-picker-month-disabled{{/disabled}}"',
                            ' data-month-of-year="{{monthOfYear}}">',
                        '<div class="uwr-month-in-num">{{monthOfYear2Digits}}</div>',
                        '<div class="uwr-month-in-txt">{{monthShort}}</div>',
                    '</div>',
                '{{/months}}',
            '</div>'
        ].join(''),

    daySelector: [
            '<div class="uwr-date-picker-day-selector">',
                '{{#months}}',
                    '<div class="uwr-date-picker-month" data-month-of-year="{{monthOfYear}}">',
                        '<div>{{month}}</div>',
                        '{{#weeks}}',
                            '<div class="uwr-date-picker-week">',
                                '{{#weekdays}}',
                                    '{{^value}}',
                                        '<span class="uwr-date-picker-cell ',
                                                'uwr-date-picker-cell-first-week uwr-date-picker-cell-empty">',
                                            '<span class="uwr-date-picker-day">&nbsp;</span>',
                                        '</span>',
                                    '{{/value}}',
                                    '{{#value}}',
                                        '<span class="uwr-date-picker-cell',
                                            '{{#hasTopBorder}} uwr-date-picker-cell-first-week{{/hasTopBorder}}">',
                                            '<span class="uwr-date-picker-day',
                                                '{{#selected}} uwr-date-picker-day-selected{{/selected}}',
                                                '{{#disabled}} uwr-date-picker-day-disabled{{/disabled}}',
                                                '{{#bankHoliday}} uwr-date-picker-day-bank-holiday{{/bankHoliday}}',
                                                '{{#today}} uwr-date-picker-day-today{{/today}}"',
                                                'data-date="{{value}}">',
                                                '{{dayOfMonth}}',
                                            '</span>',
                                            '{{#bankHoliday}}',
                                                '<span class="uwr-date-picker-day-bank-holiday-mark"></span>',
                                            '{{/bankHoliday}}',
                                            '{{#today}}',
                                                '<span class="uwr-date-picker-day-label',
                                                        '{{#selected}} uwr-date-picker-day-selected{{/selected}}">',
                                                    '{{todayAbbrev}}',
                                                '</span>',
                                            '{{/today}}',
                                        '</span>',
                                    '{{/value}}',
                                '{{/weekdays}}',
                            '</div>',
                        '{{/weeks}}',
                    '</div>',
                    '<div class="uwr-date-picker-month"></div>',
                '{{/months}}',
            '</div>'
        ].join(''),

    footer: [
            '<div class="uwr-date-picker-footer">',
                '<button class="uwr-button uwr-button-submit uwr-date-picker-done" onclick="return false;">',
                    '{{done}}',
                '</button>',
                '<button class="uwr-button uwr-date-picker-today" onclick="return false;">',
                    '{{today}}',
                '</button>',
                '<span class="uwr-date-picker-legend">',
                    '<span class="uwr-date-picker-day-bank-holiday-legend"></span>{{legendText}}',
                '</span>',
            '</div>'
        ].join('')
};



//////////////////
// WEBPACK FOOTER
// ./widgets/DatePicker/js/datePickerView.js
// module id = 9
// module chunks = main